<template>
    <b-modal
            id="forget-password-real-person"
            hide-footer
            hide-header
            no-stacking
            @shown="createCaptcha"
    >
        <template v-slot:default="{ hide }">

            <!-- Close Button Container -->
            <div class="close-button-container">
                <span class="close-button" @click="hide()">&times;</span>
            </div>
            <!-- End Close Button Container -->

            <!-- Modal Main Content -->
            <div class="modal-main-content">

                <!-- Logo -->
                <div class="logo">
                    <img src="@/assets/images/logo.png" alt="roshd logo">
                </div>
                <!-- End Logo -->

                <!-- Title -->
                <div class="heading mb-4">
                    <h6>بازیابی رمز عبور</h6>
                </div>
                <!-- End Title -->

                <!-- Form -->
                <form @submit.prevent="sendForgetCode">
                    <div class="form-group position-relative input-mobile">
                        <label>نام کاربری خود را وارد کنید</label>
                        <input type="text" name="username" class="form-control mobile-with-combo" placeholder="کد ملی">
                    </div>
                    <div class="captcha position-relative">
                        <p class="font-size-12 mb-2">کد زیر را وارد کنید</p>
                        <div class="captcha-box">
                            <img :src="`${urlCap + captchaImg}`" alt="captcha" />
                            <div
                                    class="form-group mb-0"
                                    :class="{ 'form-group--error': $v.captcha.$error }"
                            >
                                <input
                                        type="text"
                                        name="captcha"
                                        autocomplete="off"
                                        v-model.trim="captcha"
                                        @input="delayTouch($v.captcha)"
                                />
                                <div
                                        class="error captcha-required-error"
                                        v-if="!$v.captcha.required"
                                >
                                    وارد نمودن کد 4 حرفی الزامی است.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-4 mb-2">
                        <b-overlay
                                :show="busy"
                                rounded
                                opacity="0.6"
                                spinner-small
                                spinner-variant="primary"
                                class="d-flex justify-content-center align-items-center"
                        >
                            <button type="submit" :disabled="busy">ثبت</button>
                        </b-overlay>
                    </div>
                </form>
                <!-- End Form -->

            </div>
            <!-- End Modal Main Content -->

        </template>
    </b-modal>
</template>

<script>
    import axios from "@/axios.js";
    import { url, formErrors } from "@/mixins.js";
    import {minLength, required} from "vuelidate/lib/validators";
    const touchMap = new WeakMap();

    export default {
        "name": "ForgetPasswordRealPerson",
        data() {
            return {
                captchaImg: "",
                captcha: "",
                busy: false,
                errors: {
                    validate_err: "کاربر وجود ندارد.",
                    not_allowed: "کاربر مجوز تغییر رمز را ندارد یا اکانت حذف شده است.",
                    sent: "کد 5 رقمی برای شما ارسال شد."
                }
            };
        },
        mixins: [url, formErrors],
        computed: {
            urlCap() {
                return `${this.basicUrl}assets/images/captcha/`;
            },
        },
        methods: {
            createCaptcha() {
                let data = new FormData();
                data.append("action", "create_captcha");

                axios
                    .post("captcha/create.php", data)
                    .then((data) => {
                        this.captchaImg = data.data + ".png";
                        this.captcha = "";
                    })
                    .catch((err) => console.error("Err lang :", err));
            },
            async sendForgetCode(submitEvent) {

                this.busy = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    setTimeout(() => {
                        this.busy = false;
                    }, 400);
                    return;
                }

                let data = new FormData();

                data.append("forget_code", submitEvent.target.elements.username.value);
                data.append("code_type", 1);
                data.append("captcha", submitEvent.target.elements.captcha.value);

                // send code
                await axios
                    .post("user/auth/forget-pwd/forget-pwd.php", data)
                    .then((data) => {

                        switch (data.data.msg) {

                            case 11:
                                this.$snotify.warning(this.errors[data.data.msg]);
                                setTimeout(() => {
                                    this.$refs.captchaInp.focus();
                                }, 400);
                                break;

                            case "sent":
                                this.$snotify.success(this.errors[data.data.msg]);
                                this.$root.$emit("bv::show::modal", "activation-code-forget-password-real-person");

                                this.username = "";
                                break;

                            case "failure":
                                this.$snotify.warning(this.errors[data.data.msg]);
                                break;

                            case "validate_err":
                                this.$snotify.warning(this.errors[data.data.msg]);
                                break;

                            case "not_allowed":
                                this.$snotify.warning(this.errors[data.data.msg]);
                                break;

                            case "empty_err":
                                this.$snotify.warning(this.errors[data.data.msg]);
                                break;

                            default:
                                this.$snotify.error("خطا در برقراری ارتباط با سرور");
                        }

                        if (data.data.captcha) {
                            this.createCaptcha();
                        }
                    })
                    .catch((err) => console.error("Err lang :", err));

                this.busy = false;
            },
            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v));
                }
                touchMap.set($v, setTimeout($v.$touch, 1500));
            }
        },
        validations: {
            captcha: {
                required,
                minLength: minLength(4),
            },
        },
    }
</script>